import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styles from "./AssistantTestModule.module.scss";
import { Header } from "./components/Header";
import { LeftHeader } from "./components/LeftHeader";
import { SystemInstruction } from "./components/SystemInstruction";
import { DialogTest } from "./components/DialogTest";
import Slider from "../../components/AssistantNewForm/ui/Slider/Slider";
import { setUpdateAssistant } from "../../store/slices/assistantSlice";
import { putAssistant } from "../../utils/api/actions/assistant";

export const AssistantTestModule = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isLocalUpdate = useRef(false);

  const isEditFromHeader = location.state?.fromEditButton === true;

  const activeAssistant = useSelector(
    (state) => state?.assistant?.activeAssistant
  );
  const updateAssistant = useSelector(
    (state) => state?.assistant?.updateAssistant
  );

  const [openSettings, setOpenSettings] = useState(false);

  const [section] = location.pathname.split("/").filter(Boolean);
  
  const assistantName = activeAssistant?.name || "Неизвестный ассистент";
  const temperature = updateAssistant?.settings?.temperature || 0.5;
  const maxTokens = updateAssistant?.settings?.maxLength || 1024;
  const topP = updateAssistant?.settings?.topP || 1;

  useEffect(() => {
    if (!updateAssistant) {
      dispatch(setUpdateAssistant(activeAssistant));
      isLocalUpdate.current = !isEditFromHeader;
    }
  }, [updateAssistant, activeAssistant, dispatch, isEditFromHeader]);

  useEffect(() => {
    return () => {
      if (isLocalUpdate.current) {
        dispatch(setUpdateAssistant(null));
        isLocalUpdate.current = false;
      }
    };
  }, [location.pathname, dispatch]);

  const handleTemperatureObserver = (newTemperature) => {
    dispatch(
      setUpdateAssistant({
        ...updateAssistant,
        settings: {
          ...updateAssistant?.settings,
          temperature: newTemperature,
        },
      })
    );
  };

  const handleMaxTokensObserver = (newMaxTokens) => {
    dispatch(
      setUpdateAssistant({
        ...updateAssistant,
        settings: {
          ...updateAssistant?.settings,
          maxLength: newMaxTokens,
        },
      })
    );
  };

  const handleTopPObserver = (newTopP) => {
    dispatch(
      setUpdateAssistant({
        ...updateAssistant,
        settings: {
          ...updateAssistant?.settings,
          topP: newTopP,
        },
      })
    );
  };

  const hasChanges = useMemo(() => {
    const original = activeAssistant?.settings;
    const updated = updateAssistant?.settings;
    if (!original || !updated) return false;

    return (
      original.temperature !== updated.temperature ||
      original.maxLength !== updated.maxLength ||
      original.topP !== updated.topP
    );
  }, [activeAssistant, updateAssistant]);

  const handleSave = async () => {
    const updated = await dispatch(putAssistant(updateAssistant));
    if (updated) {
      dispatch(setUpdateAssistant(updated));
    }
  };

  const handleCancel = () => {
    dispatch(setUpdateAssistant(activeAssistant));
  };

  return (
    <div className={styles.container}>
      <Header assistantName={assistantName} />
      <div className={styles.wrapper}>
        <div className={styles.leftSide}>
          <LeftHeader
            openSettings={openSettings}
            setOpenSettings={setOpenSettings}
            assistantId={activeAssistant?.id}
            assistantName={assistantName}
            section={section}
          />
          <SystemInstruction activeAssistant={activeAssistant} />
          <DialogTest
            openSettings={openSettings}
            assistantName={assistantName}
          />
        </div>
        <div
          className={`${styles.rightSide} ${
            !openSettings ? styles.rightSideHidden : ""
          }`}
        >
          <Slider
            label="Температура"
            min={0}
            max={2}
            value={temperature}
            step={0.01}
            className={styles.slider}
            onChange={handleTemperatureObserver}
          />
          <Slider
            label="Макс. токенов"
            min={1}
            max={4095}
            value={maxTokens}
            step={1}
            className={styles.slider}
            onChange={handleMaxTokensObserver}
          />
          <Slider
            label="TopP"
            hint="Количество наиболее вероятных слов"
            min={0}
            max={1}
            value={topP}
            step={0.01}
            className={styles.slider}
            onChange={handleTopPObserver}
          />

          {hasChanges && (
            <div className={styles.buttons}>
              <button className={styles.saveButton} onClick={handleSave}>
                Сохранить
              </button>
              <button className={styles.cancelButton} onClick={handleCancel}>
                Отменить
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
